import styled from "styled-components";

export const App = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100%;
  background: ${(props) => props.theme.layout.bg};
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &::before {
    width: 100%;
    height: 127px;
    top: 0;
    left: 0;
    position: absolute;
    content: "";
    z-index: 1;
  }

  @media screen and (min-width: 1450px) {
    padding: 20px;
  }
`;

export const Message = styled.p`
  display: none;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 1450px;
  margin: 0 auto;
  box-shadow: ${(props) => props.theme.layout.contentBoxShadowColor};
  position: relative;
  z-index: 100;
  display: flex;
  overflow: hidden;
  flex: 1;
  min-height: 0;

  @media screen and (max-width: 900px) {
    flex-direction: column;
  }

  @media screen and (min-width: 1450px) {
    height: calc(100% - 40px);
  }
`;
